import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Upload from '../../../libCustom/upload';
import * as SalesActions from '../redux/SalesActions';

class files extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  render() {
    const { Sales } = this.props;
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <Upload
                label={''}
                files={Sales.files.length > 0 ? Sales.files : []}
                directory={'ventas'}
                bucket={'loopback-rsviajes'}
                multiple={true}
                onChange={(files) =>
                  this.props.dispatch(SalesActions.onChange(['files'], files))
                }
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(files);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/files.js